<template>
	<div class="logon" id="logon">
		<div class="logon_header w1200 flex">
			<router-link to="/" class="logon_header_logo"><img :src="public.top_logo" class="block" /></router-link>
			<div class="logon_header_r tc f16px">
				<router-link to="/" class="logon_header_list cl_dark">
					<img src="../../static/icon_index.png" />
					<p>返回首页</p>
				</router-link>
				<router-link to="" class="logon_header_list cl_dark">
					<img src="../../static/icon_logon.png" />
					<p>注册教程</p>
				</router-link>
				<router-link to="/" class="logon_header_list cl_dark">
					<img src="../../static/icon_sign.png" />
					<p>直接登录</p>
				</router-link>
			</div>
		</div>
		<div class="logon_cont">
			<div class="w1200">
				<div class="logon_mid" v-if="first">
					<div class="logon_mid_first">
						<div class="logon_mid_cont">
							<div class="logon_div">
								<div class="logon_item">
									<input type="text" v-model="mobile" placeholder="输入手机号" class="logon_item_input f16px" />
								</div>
								<div class="logon_item f16px">
									<div class="logon_item_show tc cl_white" @click="send" v-if="sendFirst">点击发送短信验证码</div>
									<div class="logon_item_hide" v-else>
										<input type="text" v-model="code" placeholder="输入验证码" class="logon_item_input f16px" />
										<button type="button" class="cl_violet logon_send" @click="send" :disabled="!sendTrue">{{sendText}}</button>
									</div>
								</div>
							</div>
							<div class="logon_item">
								<input type="password" v-model="password" placeholder="输入密码" class="logon_item_input f16px" />
							</div>
							<div class="logon_item">
								<input type="password" v-model="password_two" placeholder="请再次确认密码" class="logon_item_input f16px" />
							</div>
							<div class="logon_tip f14px">
								<label for="agree"><input type="checkbox" id="agree" v-model="agree" /><span>我已认真阅读并同意遵守趣学云</span></label>
								<router-link to="/agreement" class="cl_white">《用户注册协议》</router-link>
							</div>
							<button class="logon_submit tc f18px cl_white" :class="{on:agree}" :disabled="!agree" @click="next">注册</button>
						</div>
					</div>
					
				</div>
				<div class="logon_mid_second tc" v-else>
					<div class="logon_s_title">
						<div>
							<img src="../../static/success_green.png" />
							<p class="f16px">恭喜<span class="f20px cl_white">{{mobile}}</span>注册成功</p>
						</div>
						<p class="f18px mat30">绑定会员激活卡或在线升级你的会员权限，享受超多功能</p>
					</div>
					<div class="logon_s_cont mat30">
						<div class="logon_s_item">
							<router-link to="/vip_code" class="logon_vip f18px cl_white inline">激活</router-link>
						</div>
						<div class="logon_s_item mat30">
							<router-link to="/" class="logon_index cl_violet bg_white inline f18px">稍后激活，即刻体验</router-link>
						</div>
						<div class="logon_s_code cl_white mat50">
							<img :src="public.qr_code" />
							<p class="mat5">请关注公众号</p>
							<p>否则无法接受消息推送</p>
						</div>
					</div>
				</div>
				<div class="logon_footer tc cl_violet">
					<div class="logon_footer_top f36px">
						<img src="../../static/phone_violet.png" />
						<span>{{public.web_phone}}</span>
					</div>
					<div class="logon_footer_btm mat10">
						<p>{{public.web_copyright}} | <a href="http://www.beian.gov.cn" target="_blank" class="cl_violet">{{public.web_record}}</a></p>
						<p class="mat5">{{public.company_name}}</p>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'logon',
		components: {
		 
		},
		props: {
	
		},
		data () {
			return {
				first: true,//注册步骤
				mobile: "", //手机号
				password: "",//密码
				password_two: "",//确认密码
				agree: false,//同意
				code: "",//验证码
				timer: 60,//倒计时
				sendText: "发送验证码",
				sendFirst: true,
				sendTrue: true,
				public: {},
			}
		},
		created() {
			
		},
		mounted() {
			this.getInfo();
		},
		methods: {
			//验证码倒计时
			send() {
				var that = this;
				that.$get("/api/login/send_sms_captcha",{
					phone: that.mobile
				})
				.then(res => {
					that.sendFirst = false;
					that.sendTrue = false;
					let auth_timer = setInterval(()=>{
						that.timer--;
						that.sendText = that.timer + "s后重试"
						if(that.timer<=0){
							that.sendTrue = true;
							that.sendText = "发送验证码";
							that.timer = 60;
							clearInterval(auth_timer);
						}
					},1000)
				});
			},
			//注册
			next() {
				var that = this;
				var params = {};
				params.phone = that.mobile;
				params.code = that.code;
				params.pwd = that.password;
				params.repetition_pwd = that.password_two;
				that.$get("/api/login/register",params)
				.then(res => {
					that.first = false;
					localStorage.setItem("token", res.data.token);
				});
			},
			getInfo () {
				var that = this;
				that.$get("/api/base/get_base_configuration_data",{})
				.then(res => {
					that.public = res.data;
				});
			},
		},
	}
</script>

<style>
</style>
